/**
 * @Description 机会点项
 */

import { FC } from 'react';
import { Typography } from 'antd';
import styles from './index.module.less';
import cs from 'classnames';

export interface ChancePointItemProps {
  detail?: any; // 数据
  onClick?: Function; // 点击事件
  className?: any;
}

const ChancePointItem: FC<ChancePointItemProps> = ({ detail, onClick, className }) => {
  const colorMap = [
    { value: '#FF861D', title: ['评估中', '审批中', '签约中'] },
    { value: '#F53F3F', title: ['未通过'] },
    { value: '#999999', title: ['已关闭'] },
    { value: '#009963', title: ['通过', '落位', '已签约'] },
    { value: '#222222', title: ['待审核'] }
  ];

  const renderColor = (val: string) => {
    let color = 'blue';
    colorMap.forEach(item => {
      if (item.title.find(iitem => val?.includes(iitem))) {
        color = item.value;
      }
    });
    return color;
  };

  return (
    <div className={cs(styles.chancePointItem, className)} onClick={() => onClick?.(detail)}>
      <div className={styles.leftWrapper}>
        <img src={detail?.colorLogo || `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/img_brand.png`}/>
      </div>
      <div className={styles.rightWrapper}>
        <div className={styles.titleRow}>
          <Typography.Text className={styles.title} ellipsis={{ tooltip: detail?.name }}>
            {detail?.name}
          </Typography.Text>
          <span className={styles.status} style={{ color: renderColor(detail?.statusName) }}>
            {detail?.statusName}
          </span>
        </div>
        <div className='fs-12 c-666 mt-4'>
          <Typography.Text className={styles.address} ellipsis={{ tooltip: detail?.address }}>
            {detail?.address || '-'}
          </Typography.Text>
        </div>
      </div>

    </div>
  );
};

export default ChancePointItem;
